import { defineStore } from "pinia";

export const useStore = defineStore("store", {
  state: () => ({
    active_org: "",
    action: "",
    org_name: "",
    accounts: [], //live listner to all accounts
    active_account: "",
    start_date: "",
    end_date: "",
    journal: [],
  }),

  actions: {
    setUserData(obj) {
      this.active_org = obj.active_org;
      this.org_name = obj.org_name;
      this.start_date = obj.start_date;
      this.end_date = obj.end_date;
      this.active_account = obj.active_account;
      this.action = obj.action;
    },
    setAction(action) {
      if (this.action != action) {
        this.action = action;
      } else {
        this.action = "";
      }
    },
    setAccounts(accounts) {
      this.accounts = accounts;
    },
  },
});
